export default "__VITE_ASSET__CL1gAEGw__"